import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { SnBadgeModule } from '@lib/ui/badge';
import { SnIconModule } from '@lib/ui/icon';

import { GoogleMapComponent, GoogleMapMarkerIconComponent } from './components';
import { IGoogleMapOptions } from './map';
import { DEFAULT_MAP_OPTIONS } from './providers';
import { FsGoogleMapScreenshotService } from './services';

@NgModule({
  imports: [CommonModule, PortalModule, SnIconModule, SnBadgeModule],
  exports: [GoogleMapComponent],
  declarations: [GoogleMapComponent, GoogleMapMarkerIconComponent],
})
export class GoogleMapModule {
  public static forChild(defaultOptions: IGoogleMapOptions): ModuleWithProviders<GoogleMapModule> {
    return {
      ngModule: GoogleMapModule,
      providers: [
        FsGoogleMapScreenshotService,
        { provide: DEFAULT_MAP_OPTIONS, useValue: defaultOptions },
      ],
    };
  }
}
